import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    admProjectBillableWorkflows: [],
    count: 0,
    page: 1,
    pageSize: 10,
    pages: 0,
    sortField: 'project_name',
    sortOrder: 'desc',
    search: null,
    error: '',
    admProjectBillableWorkflowId: null,
    admTasksCountReports: [],
    admTasksCountReportCount: 0,
    admTasksCountReportPage: 1,
    admTasksCountReportPageSize: 10,
    admTasksCountReportPages: 0,
    admTasksCountReportSortField: 'id',
    admTasksCountReportSortOrder: 'desc',
    admTasksCountReportSearch: null,
    admTasksCountReportError: '',
    admTasksCountReportId: null,
    admWorkersTasksCountReports: [],
    admWorkersTasksCountReportCount: 0,
    admWorkersTasksCountReportPage: 1,
    admWorkersTasksCountReportPageSize: 10,
    admWorkersTasksCountReportPages: 0,
    admWorkersTasksCountReportSortField: 'id',
    admWorkersTasksCountReportSortOrder: 'asc',
    admWorkersTasksCountReportSearch: null,
    admWorkersTasksCountReportError: ''
}

const receivedAdmProjectBillableWorkflowsData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        admProjectBillableWorkflows: results,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search
    }
}

const receivedAdmProjectBillableWorkflowsDataError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const receivedAdmTasksCountReportsData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        admProjectBillableWorkflowId: action.admProjectBillableWorkflowId,
        admTasksCountReports: results,
        admTasksCountReportCount: count,
        admTasksCountReportPage: page,
        admTasksCountReportPageSize: pageSize,
        admTasksCountReportPages: pages,
        admTasksCountReportSortField: sortField,
        admTasksCountReportSortOrder: sortOrder,
        admTasksCountReportSearch: search
    }
}

const receivedAdmTasksCountReportsDataError=(state, action)=> {
    return {
        ...state,
        admTasksCountReportError: action.error
    }
}

const receivedAdmWorkersTasksCountReportsData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        admTasksCountReportId: action.admTasksCountReportId,
        admWorkersTasksCountReports: results,
        admWorkersTasksCountReportCount: count,
        admWorkersTasksCountReportPage: page,
        admWorkersTasksCountReportPageSize: pageSize,
        admWorkersTasksCountReportPages: pages,
        admWorkersTasksCountReportSortField: sortField,
        admWorkersTasksCountReportSortOrder: sortOrder,
        admWorkersTasksCountReportSearch: search
    }
}

const receivedAdmWorkersTasksCountReportsError=(state, action)=> {
    return {
        ...state,
        admWorkersTasksCountReportError: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.GET_ADM_PROJECTS_BILLABLE_WORKFLOWS_DATA]: receivedAdmProjectBillableWorkflowsData,
    [actionTypes.GET_ADM_PROJECTS_BILLABLE_WORKFLOWS_DATA_ERROR]: receivedAdmProjectBillableWorkflowsDataError,
    [actionTypes.GET_ADM_TASKS_COUNT_REPORTS_DATA]: receivedAdmTasksCountReportsData,
    [actionTypes.GET_ADM_TASKS_COUNT_REPORTS_DATA_ERROR]: receivedAdmTasksCountReportsDataError,
    [actionTypes.GET_ADM_WORKERS_TASKS_COUNT_REPORT_DATA]: receivedAdmWorkersTasksCountReportsData,
    [actionTypes.GET_ADM_WORKERS_TASKS_COUNT_REPORT_DATA_ERROR]: receivedAdmWorkersTasksCountReportsError
});


// WEBPACK FOOTER //
// ./src/redux/adm/reducer.js